import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { useMount } from 'ahooks';
import { buriedPointPage } from '@home/utils/buriedPoint';
import { preprocessMarkdown } from '@/pages/aigc/pages/Agent/ChatPage/utils';
import shareXing from '@/pages/aigc/assets/svg/share_xing.svg';
import SingleQA from '@/pages/aigc/pages/Agent/ChatPage/components/SingleQA';
import { capitalize, concat, isArray, isEmpty } from 'lodash-es';
import useChatHistory from '../../ChatPage/hooks/useChatHistory';
import classNames from 'classnames';
import { useChatList } from '@/pages/aigc/layouts/agentLayout/hooks';
import { ChartDSTempImg } from './ChartDSTempImg';
// 不包含ds报告的分享页面，用于普通展示
export const ChatShareConversationPage = ({ data, snapshotId, poolId, isDs, sessionId }: any) => {
  const { formatMessage } = useIntl();
  const {
    dsReport,
    handleUpdateDsReport,
    errorTipsMessage,
  } = useChatHistory();
  const { chatList, bookMarkedChats } = useChatList({ manual: true });
  const snapshotRecord = useMemo(() => {
    if (isEmpty(data)) return [];
    const processItem = (answer) => {
      const { type, value } = answer || {};
      if (type === 'think') {
        return {
          ...answer,
          value: value?.map((task) => {
            if (task.type === 'think') {
              return { ...task, value: preprocessMarkdown(task?.value) };
            }
            return task;
          }),
        };
      }
      if (type !== 'text') return answer;
      return { ...answer, value: preprocessMarkdown(value) };
    };
    const finalData = (data?.messages || []).map((conversation) => {
      const answers = conversation.answer || [];
      return {
        ...conversation,
        answer: answers.map(processItem)
      };
    });
    return finalData;
  }, [data]);

  const username = data?.user_id;
  // 获取报表模板
  const initSelectedSample = useMemo(() => {
    if (isDs) {
      return concat(chatList, bookMarkedChats).find((task) => task?.session_id === sessionId);
    }
  }, [bookMarkedChats, chatList, isDs, sessionId]);
  
  useMount(() => {
    buriedPointPage({
      pageId: '700601',
      pageName: 'agentShare',
      extInfo: snapshotId || poolId || "",
      pagePath: '/agent/chatShare',
      typeId: 'aigc',
    });
  });

  return <section className="dba-chat-page" data-is-snapshot={true}>
    <div className="dba-chat-scroll">
      <div className="dba-chat-content">
        {username && <div className='dba-snapshot-user'>
          <img className='dba-chat-title-icon' src={shareXing} alt="" />
          <span>
            {(formatMessage({ id: 'dba_chat_share_user' })).replace(/xxx/g, ` ${capitalize(username) || '-'} `)}
          </span>
        </div>}
        <ChartDSTempImg {...{
          title: initSelectedSample?.agent_title as string,
          img: initSelectedSample?.agent_banner,
          className: classNames(
            {
              "dba-chat-content-ds-snapshot": isDs && !dsReport.show,
              "dba-chat-content-ds-template": !!dsReport?.show,
            }
          )
        }} />
        {isArray(snapshotRecord) &&
          snapshotRecord?.map((conversation) => {
            const fileData = conversation?.fileData;
            const fileListResult = fileData?.length > 0 ? fileData : conversation?.frontFileList;
            const fileListData = {
              [conversation?.messageId]: fileListResult
            };
            return (
              <SingleQA
                {...{ ...conversation, conversations: snapshotRecord }}
                key={conversation.messageId}
                question={conversation?.query}
                // isLoading={isLoading}
                streamingState={null}
                // 控制反馈区是否展示
                isLastQA={null}
                isProcessing={false}
                userInfo={{ username }}
                editObj={{}}
                fileList={fileListData}
                dsReport={dsReport}
                errorTipsMessage={errorTipsMessage}
                handleUpdateDsReport={handleUpdateDsReport}
              />
            );
          })}
      </div>
    </div>
  </section>;
};